import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconWhatsApp } from 'bootstrap-icons/icons/whatsapp.svg'

const App = (props) => {
  const { t } = useTranslation();

  // Bug real (auditoría 2026-08-14): varios callers mapean un array de
  // teléfonos (item.phones/data.phones/phones) sin filtrar entradas falsy
  // antes de pasarlas acá — un phone null/undefined/"" (un slot vacío en el
  // array) llegaba hasta el `phone.label` de la rama corta de abajo y
  // crasheaba con "Cannot read properties of undefined/null (reading
  // 'label')", tirando abajo toda la lista que lo contenía.
  if (!props.phone) return null;

  let phone = props.phone;

  if (phone?.constructor === String) {
    phone = { label: phone, value: phone };
  }

  const number = Number(phone?.value?.replace(/\D/g, "") || "").toString();


  if (number.length <= 8)
    return <span className={props.className || ""}>{phone.label}</span>;

  let params = new URLSearchParams({
    phone: number,
    text: props.text || '',
    type: 'phone_number',
    app_absent: 0
  }).toString()

  return (
    <a
      className={`link-success user-select-all ${
        props.className || ""
      }`}
      target="whatsapp"
      rel="noopener noreferrer"
      data-tooltip-id="app-tooltip"
      // `tooltipSuffix` es opt-in: quien no lo pase ve el tooltip de siempre. Lo usa el
      // listado de profesionales para colgar el "+n" de teléfonos que no está mostrando.
      data-tooltip-content={`${t(
        "open_and_send_whatsapp",
        "Abre WhatsApp en una nueva pestaña listo para enviarle un mensaje"
      )}${props.tooltipSuffix || ""}`}
      href={`https://api.whatsapp.com/send/?${params}`}
    >
      <IconWhatsApp className={props.classNameIcon || 'me-1 mt-n1'} width={props.size || '16'} height={props.size || '16'} />{' '}
      {phone.label || number}
    </a>
  );
};

export default App;
